import formEmbeddableMixin from "@/mixins/embeddable/resource/formEmbeddableMixin";
import ProductionOrderFormUniqueBatchEmbeddable from "@/views/modules/production/ProductionOrder/embeddable/ProductionOrderFormUniqueBatchEmbeddable";
import ProductionOrderEntity from "@/model/entities/modules/production/ProductionOrderEntity";


export default {
    components: {ProductionOrderFormUniqueBatchEmbeddable},
    mixins: [formEmbeddableMixin],
    data() {
        return {
            path: "production/order", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
            form: new ProductionOrderEntity()
        }

    },
    /*created(){
        this.form =
    },*/
    methods: {


    }
}